import { useState } from 'react';
import { login } from '../firebase/auth';
import { Button, Field, TextInput } from '../ui/components';

export default function AdminLogin() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState(null);
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError('Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adm-login">
      <div className="adm-login__card">
        <div className="adm-login__logo">
          <img src="/klaivox_icon_zoomed_2x.svg" alt="Klaivox" />
        </div>
        <h1 className="adm-login__title">Admin Panel</h1>
        <p className="adm-login__sub">Sign in to manage your website content</p>

        <form className="adm-login__form" onSubmit={handleSubmit}>
          <Field className="adm-field" labelClassName="adm-label" label="Email">
            <TextInput
              type="email"
              className="adm-input"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
              autoComplete="email"
            />
          </Field>

          <Field className="adm-field" labelClassName="adm-label" label="Password">
            <TextInput
              type="password"
              className="adm-input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </Field>

          {error && <p className="adm-error">{error}</p>}

          <Button
            type="submit"
            fullWidth
            disabled={loading}
            loading={loading}
          >
            Sign In
          </Button>
        </form>
      </div>
    </div>
  );
}
